import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Booking from "@/pages/Booking";
import BookPage from "@/pages/BookPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import UpgradeBooking from "@/pages/UpgradeBooking";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Terms from "@/pages/Terms";
import PrivacyRefund from "@/pages/PrivacyRefund";
import RefundPolicy from "@/pages/RefundPolicy";
import TermsAndPrivacy from "@/pages/TermsAndPrivacy";
import About from "@/pages/About";
import InviteRedeem from "@/pages/InviteRedeem";
import Review from "@/pages/Review";
import Account from "@/pages/Account";

import "@/App.css";

function App() {
  return (
    <div className="App" dir="rtl" lang="ar">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/booking/:serviceId" element={<Booking />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/upgrade/:bookingId" element={<UpgradeBooking />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-refund" element={<PrivacyRefund />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms-and-privacy" element={<TermsAndPrivacy />} />
            <Route path="/about" element={<About />} />
            <Route path="/invite/:token" element={<InviteRedeem />} />
            <Route path="/review/:token" element={<Review />} />
            <Route path="/account" element={<Account />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
